import React, { memo } from 'react';
import { useSelector } from 'react-redux';

import { Box } from '@mui/material';

import { selectQuery } from 'rdx/router';

import SaveChanges from './SaveChanges';

interface MenuContentFooterProps {
  onSave: () => void;
  onReset: () => void;
  isSavingDisabled: boolean;
}

const MenuContentFooter: React.FC<MenuContentFooterProps> = ({
  onSave,
  onReset,
  isSavingDisabled,
}) => {
  const query = useSelector(selectQuery);

  if (query.mode !== 'edit') {
    return null;
  }

  return (
    <Box display="flex" alignItems="center" justifyContent="flex-end" py={2} px={2}>
      <SaveChanges onSave={onSave} isSavingDisabled={isSavingDisabled} onReset={onReset} />
    </Box>
  );
};

export default memo(MenuContentFooter);
